'use client';

import { styled } from '@mui/material/styles';

export const Anchor = styled( 'a' )( {} );
